import React from 'react'

import { Slider } from '@amusnet/react-ui'
import { IAutoplaySliderItem } from './useAutoplaySliderItems'
import { formatMoney } from '@utils/money'
import { useConfigurationStore } from '@stores'

interface AutoplaySliderItemProps {
    item: IAutoplaySliderItem
    currency: string
    id?: string
}

const AutoplaySliderItem: React.FC<AutoplaySliderItemProps> = ({ item, currency, id }) => {
    const { currentValue, onChange, maxValue, title, onSetEngineValue } = item
    const shouldHideCents = useConfigurationStore((s) => s.currencyHideCents)

    const titleStyle = `text-3xl font-bold text-white tracking normal`

    return (
        <div id={id} className="flex flex-col gap-10">
            <div className="flex justify-between">
                <h4 className={titleStyle}>{title}</h4>
                <div className="inline-flex gap-1 items-baseline">
                    <span className={titleStyle}>{formatMoney(Math.round(currentValue), shouldHideCents)}</span>
                    <span className="text-[21px] leading-[36px] text-white font-black">{currency}</span>
                </div>
            </div>
            <div className="max-w-[510px] m-auto w-full">
                <Slider
                    onSetEngineValue={onSetEngineValue}
                    value={currentValue}
                    onChange={onChange}
                    currency={currency}
                    max={maxValue}
                    valueFormatter={formatMoney}
                    hideCents={shouldHideCents}
                />
            </div>
        </div>
    )
}

export default AutoplaySliderItem
